import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import CampaignEmailCreation from "./campaign-email-creation";
import CampaignEmailVerification from "./campaign-email-verification";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { CREATE_MARKETING_EMAIL, VERIFY_MARKETING_EMAIL } from "../../store/marketing/marketing-actions";
import { EMPTY_CURRENT_EMAIL } from "../../store/marketing/marketing-mutations";
import { mapActions, mapMutations } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreateEmailModal",
  components: {
    GenericModal,
    CampaignEmailCreation,
    CampaignEmailVerification,
    SimpleButton
  },
  mixins: [validationMixin],
  props: {
    forceShowVerify: {
      type: Boolean,
      default: null
    },
    forceEmailToVerify: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modalOpened: false,
      localShowVerify: false,
      showNotVerifiedMssg: false,
      submitting: {
        loading: false,
        status: true
      },
      verifying: {
        loading: false,
        status: true
      }
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: _objectSpread(_objectSpread({}, mapFields("MarketingStore", ["currentEmail.emailId", "currentEmail.email", "currentEmail"])), {}, {
    isValid() {
      return !this.$v.$invalid;
    },
    showVerify() {
      return this.forceShowVerify || this.localShowVerify;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("MarketingStore", [CREATE_MARKETING_EMAIL, VERIFY_MARKETING_EMAIL])), mapMutations("MarketingStore", [EMPTY_CURRENT_EMAIL])), {}, {
    handleShow() {
      this.modalOpened = true;
      this.$showModal();
    },
    handleHidden() {
      this.localShowVerify = false;
      this.modalOpened = false;
      this.$emit("close-modal");
      this.EMPTY_CURRENT_EMAIL();
    },
    async handleVerifyEmail() {
      try {
        this.verifying.loading = true;
        const forceEmailToVerify = this.forceShowVerify && this.forceEmailToVerify || this.currentEmail;
        await this.VERIFY_MARKETING_EMAIL({
          forceEmailToVerify
        });
        this.$refs.createEmailModal.hide();
        this.$emit("auto-select-email", forceEmailToVerify.emailId);
        this.showNotVerifiedMssg = false;
        this.EMPTY_CURRENT_EMAIL();
      } catch (e) {
        this.showNotVerifiedMssg = true;
        this.verifying.status = false;
      } finally {
        this.verifying.loading = false;
      }
    },
    async handleCreateEmail() {
      try {
        this.submitting.loading = true;
        await this.CREATE_MARKETING_EMAIL();
        this.localShowVerify = true;
      } catch (e) {
        this.submitting.status = false;
      } finally {
        this.submitting.loading = false;
      }
    }
  })
});